// extracted by mini-css-extract-plugin
module.exports = {"kanban__wrapper":"kanban_kanban__wrapper__13u4Y"};